import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { hoa: String }

  static targets = ['entry', 'btn']

  connect() {
    const saved = localStorage.getItem(this.storageKey)
    if (saved) {
      this.applyFilter(saved)
    }
  }

  filter(event) {
    const { userId } = event.currentTarget.dataset
    this.applyFilter(userId)
  }

  applyFilter(userId) {
    this.entryTargets.forEach((el) => {
      if (userId === 'all') {
        el.hidden = false
      } else {
        el.hidden = el.dataset.userId !== userId
      }
    })

    this.btnTargets.forEach((btn) => {
      btn.classList.toggle('btn-active', btn.dataset.userId === userId)
    })

    if (userId === 'all') {
      localStorage.removeItem(this.storageKey)
    } else {
      localStorage.setItem(this.storageKey, userId)
    }
  }

  get storageKey() {
    return `ledger_filter_${this.hoaValue}`
  }
}
